import React, { useCallback, useState } from "react";

import SurflineAPI from "../../api/SurflineAPI";
import {
  Input,
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  Row,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Button,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Col from "reactstrap/lib/Col";

const AddSurflineSource = ({ onSelect, onCancel, ...props }) => {
  const fetchSearchResults = async (query) => {
    return await SurflineAPI.search(query).then(
      (res) => {
        setSpots(res.data[0].hits.hits);
      },
      (err) => {
        console.error(err);
      }
    );
  };

  const handleSpotSelect = (spotData) => {
    const formatted = {
      name: spotData._source.name,
      vendor: "surfline",
      uniqueId: spotData._id,
    };
    setSelectedSpot(formatted);
  };

  const handleSubmit = () => {
    onSelect(selectedSpot);
  };

  const [selectedSpot, setSelectedSpot] = useState();

  const [spots, setSpots] = useState([]);

  const callbackRef = useCallback((inputElement) => {
    if (inputElement) {
      inputElement.focus();
    }
  }, []);
  return (
    <>
      <Row>
        <Col xs={12}>
          <Row>
            <Col xs={12}>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  onChange={(e) => {
                    fetchSearchResults(e.target.value);
                  }}
                  innerRef={callbackRef}
                  placeholder="Search for a Spot or Region"
                />
              </InputGroup>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col xs={12}>
              <ListGroup className="mt-2">
                {spots.length ? (
                  spots.map((spot) => (
                    <ListGroupItem
                      key={spot._id}
                      className={`cursor-default ${spot._id ===
                        selectedSpot?.uniqueId && "active"}`}
                      onClick={() => {
                        handleSpotSelect(spot);
                      }}
                    >
                      <>
                        <strong>{spot._source.name} </strong>
                        <span className="ml-2 text-secondary">
                          {spot._source.breadCrumbs[0]} /{" "}
                          {spot._source.breadCrumbs.slice(-1)}
                        </span>
                      </>
                    </ListGroupItem>
                  ))
                ) : (
                  <ListGroupItem>
                    <ListGroupItemHeading className="text-center align-middle d-inline">
                      No Spots found.
                    </ListGroupItemHeading>
                  </ListGroupItem>
                )}
              </ListGroup>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row noGutters className="mt-2">
        <Col xs="auto" className="ml-auto">
          <Button color="primary" onClick={handleSubmit}>
            Confirm
          </Button>
        </Col>
        <Col xs="auto">
          <Button color="link" onClick={onCancel}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default AddSurflineSource;
